export default __webpack_public_path__ + "static/young-coders-after-school-classes-f6c9edf55337d5d2878862e02b94a12a.jpg";